import { useEffect, useRef } from 'react';
import { useHighlightConditionBoxes, HighlightConditionBoxesWrapper } from '../../hooks/useHighlightConditionBoxes';
import { jsx as _jsx } from "react/jsx-runtime";
const RefHighlightContainer = props => {
  const {
    children,
    isEditor = false,
    shouldHighlight,
    onHighlightFinish,
    targetSelector,
    scrollIntoViewOptions = {
      behavior: 'smooth',
      block: 'start'
    }
  } = props;
  const {
    isHighlighted,
    highlightConditionBoxes,
    unhighlightConditionBoxes
  } = useHighlightConditionBoxes(onHighlightFinish);
  const containerRef = useRef(null);
  const timeoutIdsRef = useRef([]);
  useEffect(() => {
    if (shouldHighlight) {
      const timeoutId = setTimeout(() => {
        if (containerRef.current) {
          containerRef.current.scrollIntoView({
            behavior: scrollIntoViewOptions.behavior,
            block: scrollIntoViewOptions.block
          });
          highlightConditionBoxes();
        }
      }, 0);
      timeoutIdsRef.current.push(timeoutId);
    } else {
      unhighlightConditionBoxes();
    }
    const timeoutIds = timeoutIdsRef.current;
    return () => {
      while (timeoutIds.length) {
        clearTimeout(timeoutIds.pop());
      }
    };
  }, [containerRef, shouldHighlight, highlightConditionBoxes, unhighlightConditionBoxes, scrollIntoViewOptions.behavior, scrollIntoViewOptions.block]);
  return /*#__PURE__*/_jsx(HighlightConditionBoxesWrapper, {
    isHighlighted: isHighlighted,
    isEditor: isEditor,
    ref: containerRef,
    targetSelector: targetSelector,
    children: children
  });
};
export default RefHighlightContainer;